import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { State } from "@App/state";
import { ContactPartner } from "@App/Components/ContactPartner";

type ContactUsProps = {
  titleHidden?: boolean;
  hidePartner?: boolean;
  imageHidden?: boolean;
};

export const ContactUs: FunctionComponent<ContactUsProps> = ({
  titleHidden = false,
  hidePartner = false,
  imageHidden = false,
}) => {
  const { t } = useTranslation();
  const organization = useSelector((state: State) => state.orders.organization);

  if (!organization) return null;

  const imageSrc = organization.settings?.contactDetails?.image ?? "/images/paulina-rounded.webp";

  return (
    <div>
      <div
        className={`footerBlockHeadline text-2xl font-serif text-neutral-700 mb-3 ${
          titleHidden && "hidden md:block"
        }`}
      >
        {!titleHidden && t("contact.title")}&nbsp;
      </div>

      <p>{t("contact.text")}</p>

      <div className={`flex gap-2 my-3 ${imageHidden ? "items-start" : ""}`}>
        {!imageHidden && (
          <img
            data-testid="contact-image"
            className="max-w-[70px] max-h-[70px] md:max-w-[96px] md:max-h-[96px]"
            src={imageSrc}
            alt=""
          />
        )}

        <table className={`${imageHidden ? "w-full" : ""}`}>
          <tbody className="align-top">
            <tr>
              <td className="w-[60px] text-sm md:text-base leading-6">
                {t("contact.phone.label")}
              </td>
              <td>
                <a className="text-neutral-700 no-underline" href={t("contact.phone.link")}>
                  {t("contact.phone.title")}
                </a>
                <br />
                <span className="whitespace-pre-line text-xs lg:text-base">
                  {t("contact.reachability")}
                </span>
              </td>
            </tr>
            <tr>
              <td className="w-[60px] text-sm md:text-base leading-6">
                {t("contact.email.label")}
              </td>
              <td>
                <a className="text-sm md:text-base" href={t("contact.email.link")}>
                  {t("contact.email.title")}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {!hidePartner && t("contact.partner", { defaultValue: null }) && (
        <ContactPartner
          showTitle={false}
          organization={organization}
          partnerLogo={{
            url: organization?.settings?.navbar?.partnerLogo.url ?? "",
            alt: t("layout.navbar.partnerLogo.alt"),
          }}
        />
      )}
    </div>
  );
};
